const AccessPermission = {
    viewUpdatePermission: "VU",
    viewPermission:"V",
    notAuthorizedPermission: "NA",
}

export default AccessPermission;


// WEBPACK FOOTER //
// ./src/components/Helpers/AccessPermission.js